import classNames from 'classnames'
import { ElementType } from 'react'

import { Box } from '../../components/Box'
import { Badge } from '../../components/Badge'

import { DetailsProps } from './types'
import { Swatches } from './Swatches'
import { useProductCardContext } from './ProductCard'

const defaultElement = 'div'

export const Details = <C extends ElementType = typeof defaultElement>({
  className,
  as,
  leftIndent = false,
  title,
  price,
  color,
  compareAtPrice,
  primaryBadge,
  secondaryBadge,
  selectedSwatchId,
  swatches = [],
  onSwatchSelect = () => {},
  availableColors = {},
  canonicalColors = {},
  isLoadingAdditionalData = false,
  useSwatches = false,
  ...props
}: DetailsProps<C>) => {
  const { href } = useProductCardContext()
  const element: React.ElementType = as || defaultElement

  return (
    <Box
      as={element}
      className={classNames(
        'product-card__details',
        { 'product-card__details--left-indent': leftIndent },
        className,
      )}
      {...props}
    >
      {primaryBadge && (
        <Badge
          color={primaryBadge?.color}
          size={primaryBadge?.size}
          variant={primaryBadge.variant}
        >
          {primaryBadge?.text}
        </Badge>
      )}
      <a href={href}>
        <p className="product-card__details__title">{title}</p>
        {!useSwatches && color && (
          <p className="product-card__details__color">{color}</p>
        )}
        <p className="product-card__details__price">
          {price} <s>{compareAtPrice}</s>
        </p>
      </a>
      {useSwatches && swatches.length > 0 && (
        <Swatches
          swatches={swatches}
          selectedSwatchId={selectedSwatchId}
          onSwatchSelect={onSwatchSelect}
          availableColors={availableColors}
          canonicalColors={canonicalColors}
          isLoading={isLoadingAdditionalData}
        />
      )}
      {secondaryBadge && (
        <Badge
          className="mt-3"
          color={secondaryBadge?.color}
          size={secondaryBadge?.size}
          variant={secondaryBadge.variant}
        >
          {secondaryBadge?.text}
        </Badge>
      )}
    </Box>
  )
}
